<div class="container">
  Belastungsstufe:
  <div matTooltip="{{belastungsstufe.indexAsString}}"
       class="panel" [class]="visualizeBelastungsstufe(belastungsstufe.index)">
  </div>
</div>
